import { render } from "./approval.vue?vue&type=template&id=2d662989&scoped=true"
import script from "./approval.vue?vue&type=script&lang=ts"
export * from "./approval.vue?vue&type=script&lang=ts"

import "./approval.vue?vue&type=style&index=0&id=2d662989&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d662989"

export default script